import { ArrowDownIcon, ArrowUpIcon, TrashIcon } from "@/assets/icons";
import { PoiBrandSearch } from "@/types/poiParameter";

interface CategoryItemProps {
  categoryKey: string;
  categoryLabel: string;
  items: PoiBrandSearch[];
  isExpanded: boolean;
  onToggleExpand: (key: string) => void;
  onDeleteAll: (key: string) => void;
  onDeleteItem: (key: string, itemId: string) => void;
}

export const CategoryItem = ({
  categoryKey,
  categoryLabel,
  items,
  isExpanded,
  onToggleExpand,
  onDeleteAll,
  onDeleteItem
}: CategoryItemProps) => {
  return (
    <div className="border border-[#eee] rounded-[12px] overflow-hidden">
      <div className="bg-[#f7f7f7] p-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-sm text-txtHeading leading-[22px]">
            {categoryLabel} ({items.length})
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onDeleteAll(categoryKey)}
            className="text-xs text-[#4c7dfb] hover:opacity-80 transition-opacity"
          >
            Delete All
          </button>
          <button
            type="button"
            data-testid={`toggle-expand-${categoryKey}`}
            onClick={() => onToggleExpand(categoryKey)}
            className="p-0.5 hover:bg-gray-200 rounded transition-colors"
          >
            {isExpanded ? (
              <ArrowUpIcon className="w-4 h-4 fill-[#101010]" />
            ) : (
              <ArrowDownIcon className="w-4 h-4 fill-[#101010]" />
            )}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="px-2">
          {items.map((item) => (
            <div
              key={item.brand_code}
              className="p-2 flex items-center justify-between"
            >
              <span className="text-xs text-txtBody font-semibold leading-[22px]">
                {item.brand_name}
              </span>
              <button
                type="button"
                onClick={() => onDeleteItem(categoryKey, item.brand_code)}
              >
                <TrashIcon className="w-4 h-4 fill-txtBody" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
